import { render } from "./ReferralsForm.vue?vue&type=template&id=3305ea28"
import script from "./ReferralsForm.vue?vue&type=script&lang=js"
export * from "./ReferralsForm.vue?vue&type=script&lang=js"

import "./ReferralsForm.vue?vue&type=style&index=0&id=3305ea28&lang=css"

import exportComponent from "C:\\Users\\EFRENBP\\Desktop\\Projects\\2022\\03-Landing referidos\\AM-referidos\\am-referrals router\\am-referrals\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__